import { jsxs as l, jsx as n } from "react/jsx-runtime";
import { _ as t } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index35.css';const u = "_input-label_yjedu_1", c = "_disabled_yjedu_7", o = "_required_yjedu_11", e = {
  inputLabel: u,
  disabled: c,
  required: o
};
function m(i) {
  const {
    children: d,
    className: r,
    disabled: s,
    required: a
  } = i;
  return d ? /* @__PURE__ */ l(
    "div",
    {
      className: t(
        e.inputLabel,
        s && e.disabled,
        r
      ),
      children: [
        d,
        a && /* @__PURE__ */ n("span", { "aria-hidden": !0, className: e.required, children: "*" })
      ]
    }
  ) : null;
}
export {
  m as default
};
